import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'
import { isTestCafeAuthEnabled } from '@/helpers/isTestCafeEnabled'
import type {
  LoginCredentials,
  AuthenticateResponse,
  AuthenticateTokenResponse,
  MfaVerifyPayload,
  ValidateResponse,
  LogoutResponse
} from '@/types'
import type { AxiosResponse } from 'axios'

const authPrefix = isTestCafeAuthEnabled()
  ? import.meta.env.VITE_APP_API_BASE_AUTH_TESTCAFE_URL
  : import.meta.env.VITE_APP_API_BASE_AUTH_URL

export default {
  authenticate(
    payload: LoginCredentials | MfaVerifyPayload
  ): Promise<AxiosResponse<AuthenticateResponse>> {
    const auth = `${authPrefix}authenticate`
    return http.post(auth, payload)
  },
  verifyMfaCode(payload: MfaVerifyPayload): Promise<AxiosResponse<AuthenticateTokenResponse>> {
    const auth = `${authPrefix}authenticate`
    return http.post(auth, payload)
  },
  validate(token: string): Promise<AxiosResponse<ValidateResponse>> {
    return http.get(endpoints.get('auth', { action: 'validate' }), {
      params: { token }
    })
  },
  logout(): Promise<AxiosResponse<LogoutResponse>> {
    return http.post(endpoints.get('auth', { action: 'logout' }))
  },
  refresh(): Promise<AxiosResponse<ValidateResponse>> {
    return http.post(endpoints.get('auth', { action: 'refresh' }))
  }
}
